module.exports = __webpack_public_path__ + "img/acd3b19.png";